import { ReactAppProcessEnv, StandardProceessEnv } from '@iotv/iotv-v3-types'

export const STD_PROCESS_ENV = (({ AWS_DEFAULT_REGION, AWS_PROFILE, accountId, projectCode, projectName, stage }: Partial<StandardProceessEnv>) => ({
  AWS_DEFAULT_REGION,
  AWS_PROFILE,
  accountId,
  projectCode,
  projectName,
  stage,
}))(process.env as Partial<StandardProceessEnv>)

export const REACT_APP_PROCESS_ENV = (({
  REACT_APP_CURRENT_GIT_SHA,
  REACT_APP_AWS_ACCOUNT_ID,
  REACT_APP_DEPLOYMENT_STAGE,
  REACT_APP_PROJECT_CODE,
  REACT_APP_PROJECT_NAME,
  REACT_APP_AWS_DEFAULT_REGION,
}: Partial<ReactAppProcessEnv>) => ({
  REACT_APP_CURRENT_GIT_SHA,
  REACT_APP_AWS_ACCOUNT_ID,
  REACT_APP_DEPLOYMENT_STAGE,
  REACT_APP_PROJECT_CODE,
  REACT_APP_PROJECT_NAME,
  REACT_APP_AWS_DEFAULT_REGION,
}))(process.env as Partial<ReactAppProcessEnv>)
